// ion-gpt-logic.js — FULL BLOCK SWAP (UI POLISH ONLY, NO LOGIC CHANGES)
// ✅ No frontend API key
// ✅ All calls via Cloudflare proxy
// ✅ Same threading / polling behavior
// ✅ Premium Tesla-glass styling (scoped), message bubbles, better typography
// ✅ PATCH: force-style launcher via DOM detection (beats inline teal)

const ION_PROXY_BASE = "https://ion-gpt-proxy.elpadrinoypatron.workers.dev";
const POLL_INTERVAL_MS = 1200;
const POLL_TIMEOUT_MS = 45000;
const ION_ASSISTANT_ID = "asst_RDlmbMHKptzUhfKd3xYjMuHj";

// ---------- UI: Inject Premium Styles (scoped) ----------
function injectIonGptPremiumStyles() {
  if (document.getElementById("ion-gpt-premium-styles")) return;

  const style = document.createElement("style");
  style.id = "ion-gpt-premium-styles";
  style.textContent = `
  /* ===== ION GPT — Premium Tesla Glass Theme (Scoped) ===== */
  #ion-gpt-window {
    --ion-bg: rgba(8, 8, 10, 0.78);
    --ion-panel: rgba(12, 12, 14, 0.72);
    --ion-border: rgba(255, 255, 255, 0.16);
    --ion-border-strong: rgba(255, 255, 255, 0.28);
    --ion-text: rgba(255,255,255,0.92);
    --ion-muted: rgba(255,255,255,0.62);
    --ion-glow: rgba(0, 255, 220, 0.22);
    --ion-glow-soft: rgba(0, 255, 220, 0.10);
    --ion-radius: 18px;
    --ion-radius-inner: 14px;
    --ion-shadow: 0 22px 80px rgba(0,0,0,0.60);
    --ion-font: Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;

    font-family: var(--ion-font);
    background:
      radial-gradient(1200px 700px at 50% 0%, var(--ion-glow-soft), rgba(0,0,0,0) 55%),
      var(--ion-bg) !important;
    border: 1px solid var(--ion-border) !important;
    border-radius: var(--ion-radius) !important;
    box-shadow: var(--ion-shadow) !important;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    overflow: hidden;
    position: relative;
  }

  /* Subtle grain overlay */
  #ion-gpt-window::after {
    content: "";
    position: absolute;
    inset: -20%;
    pointer-events: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='220' height='220'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='220' height='220' filter='url(%23n)' opacity='.35'/%3E%3C/svg%3E");
    mix-blend-mode: overlay;
    opacity: .06;
    transform: rotate(1deg);
  }

  /* Header strip */
  #ion-gpt-window .ion-gpt-header,
  #ion-gpt-window #ion-gpt-header,
  #ion-gpt-window .header,
  #ion-gpt-window header {
    background:
      radial-gradient(900px 240px at 50% 0%, rgba(0,255,220,0.10), rgba(0,0,0,0) 60%),
      linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02)) !important;
    border-bottom: 1px solid rgba(255,255,255,0.16) !important;
    color: rgba(255,255,255,0.92) !important;
    text-shadow: 0 0 18px rgba(0,255,220,0.10);
    letter-spacing: 0.10em;
    text-transform: uppercase;
    font-weight: 900;
  }

  #ion-gpt-window .ion-gpt-header *,
  #ion-gpt-window #ion-gpt-header *,
  #ion-gpt-window header * {
    color: rgba(255,255,255,0.92) !important;
    font-weight: 900 !important;
    letter-spacing: 0.10em !important;
    text-transform: uppercase !important;
  }

  /* Messages container */
  #ion-gpt-messages {
    padding: 14px 14px 10px !important;
    color: var(--ion-text) !important;
  }

  /* Message bubbles */
  #ion-gpt-messages .ion-msg {
    display: block;
    width: fit-content;
    max-width: 92%;
    padding: 10px 12px;
    margin: 10px 0;
    border-radius: var(--ion-radius-inner);
    border: 1px solid rgba(255,255,255,0.10);
    background: rgba(255,255,255,0.04);
    box-shadow: 0 10px 35px rgba(0,0,0,0.22);
    line-height: 1.35;
    font-size: 0.95rem;
    position: relative;
    z-index: 1;
  }

  #ion-gpt-messages .ion-msg b {
    display: inline-block;
    margin-right: 6px;
    color: rgba(255,255,255,0.88);
    font-weight: 900;
    letter-spacing: 0.02em;
  }

  #ion-gpt-messages .ion-msg--assistant {
    background: rgba(255,255,255,0.04);
    border-color: rgba(255,255,255,0.10);
  }

  #ion-gpt-messages .ion-msg--user {
    margin-left: auto;
    background: rgba(0,255,220,0.06);
    border-color: rgba(0,255,220,0.16);
  }

  /* Typing dots wrapper */
  #ion-gpt-typing.ion-typing {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    border-radius: var(--ion-radius-inner);
    border: 1px solid rgba(255,255,255,0.10);
    background: rgba(255,255,255,0.03);
    width: fit-content;
    max-width: 92%;
    margin: 10px 0;
  }

  #ion-gpt-typing.ion-typing span {
    width: 6px;
    height: 6px;
    border-radius: 999px;
    background: rgba(255,255,255,0.55);
    box-shadow: 0 0 14px rgba(0,255,220,0.12);
    animation: ionDot 1.2s infinite ease-in-out;
  }
  #ion-gpt-typing.ion-typing span:nth-child(2) { animation-delay: 0.15s; }
  #ion-gpt-typing.ion-typing span:nth-child(3) { animation-delay: 0.30s; }
  @keyframes ionDot {
    0%, 80%, 100% { transform: translateY(0); opacity: 0.45; }
    40% { transform: translateY(-3px); opacity: 0.9; }
  }

  #ion-gpt-input-container {
    padding: 12px 14px 14px !important;
    border-top: 1px solid var(--ion-border) !important;
    background: linear-gradient(180deg, rgba(0,0,0,0), rgba(0,0,0,0.18)) !important;
    position: relative;
    z-index: 1;
  }

  #ion-gpt-input {
    background: rgba(0,0,0,0.22) !important;
    border: 1px solid var(--ion-border) !important;
    border-radius: 14px !important;
    color: var(--ion-text) !important;
    outline: none !important;
    box-shadow: inset 0 0 0 1px rgba(255,255,255,0.02);
  }
  #ion-gpt-input::placeholder { color: rgba(255,255,255,0.40) !important; }

  #ion-gpt-input:focus {
    border-color: rgba(0,255,220,0.35) !important;
    box-shadow:
      0 0 0 4px rgba(0,255,220,0.10),
      0 0 24px rgba(0,255,220,0.10) !important;
  }

  #ion-gpt-input-container button {
    border-radius: 14px !important;
    border: 2px solid rgba(255,255,255,0.82) !important;
    background: rgba(0,0,0,0.20) !important;
    color: #fff !important;
    font-weight: 900 !important;
    letter-spacing: 0.12em !important;
    text-transform: uppercase !important;
    transition: transform .18s ease, background .18s ease, border-color .18s ease, box-shadow .18s ease;
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
  }
  #ion-gpt-input-container button:hover {
    transform: translateY(-1px);
    background: rgba(255,255,255,0.05) !important;
    border-color: rgba(0,255,220,0.55) !important;
    box-shadow: 0 0 26px rgba(0,255,220,0.12);
  }
  #ion-gpt-input-container button:active { transform: translateY(0px); }

  #ion-gpt-messages.fade-shadow {
    mask-image: linear-gradient(to bottom, transparent 0px, black 18px, black calc(100% - 18px), transparent 100%);
    -webkit-mask-image: linear-gradient(to bottom, transparent 0px, black 18px, black calc(100% - 18px), transparent 100%);
  }
  `;
  document.head.appendChild(style);

  // Add header class if markup doesn't already have it (safe)
  const header =
    document.querySelector("#ion-gpt-window .ion-gpt-header") ||
    document.querySelector("#ion-gpt-window header") ||
    document.querySelector("#ion-gpt-window .header") ||
    null;
  if (header && !header.classList.contains("ion-gpt-header")) header.classList.add("ion-gpt-header");
}

/* =========================================================================
   LAUNCHER FIX (UI-only): find the teal square launcher and force Tesla-glass
   This beats inline styles + works even if the launcher has random selectors.
   ========================================================================= */

function styleIonLauncher(el) {
  if (!el) return false;
  if (el.dataset.ionLauncherStyled === "1") return true;

  // Force styles (inline) to override whatever the widget sets
  el.style.setProperty("background",
    "radial-gradient(120px 120px at 50% 35%, rgba(0,255,220,0.20), rgba(0,0,0,0) 60%), rgba(8,8,10,0.72)",
    "important"
  );
  el.style.setProperty("border", "1px solid rgba(255,255,255,0.18)", "important");
  el.style.setProperty("border-radius", "18px", "important");
  el.style.setProperty("backdrop-filter", "blur(10px)", "important");
  el.style.setProperty("-webkit-backdrop-filter", "blur(10px)", "important");
  el.style.setProperty("box-shadow",
    "0 18px 60px rgba(0,0,0,0.55), 0 0 32px rgba(0,255,220,0.16)",
    "important"
  );
  el.style.setProperty("transition",
    "transform .18s ease, border-color .18s ease, box-shadow .18s ease, background .18s ease",
    "important"
  );

  // Make icon look less sticker-y
  const icon = el.querySelector("img, svg");
  if (icon) {
    icon.style.setProperty("filter", "drop-shadow(0 0 14px rgba(0,255,220,0.14))", "important");
    icon.style.setProperty("opacity", "0.92", "important");
  }

  // Add hover/active feel safely
  if (!el.dataset.ionHoverBound) {
    el.addEventListener("mouseenter", () => {
      el.style.setProperty("transform", "translateY(-1px)", "important");
      el.style.setProperty("border-color", "rgba(0,255,220,0.38)", "important");
      el.style.setProperty("box-shadow",
        "0 22px 70px rgba(0,0,0,0.62), 0 0 46px rgba(0,255,220,0.20)",
        "important"
      );
    });
    el.addEventListener("mouseleave", () => {
      el.style.setProperty("transform", "translateY(0px)", "important");
      el.style.setProperty("border-color", "rgba(255,255,255,0.18)", "important");
      el.style.setProperty("box-shadow",
        "0 18px 60px rgba(0,0,0,0.55), 0 0 32px rgba(0,255,220,0.16)",
        "important"
      );
    });
    el.addEventListener("mousedown", () => {
      el.style.setProperty("transform", "translateY(0px)", "important");
    });
    el.addEventListener("mouseup", () => {
      el.style.setProperty("transform", "translateY(-1px)", "important");
    });
    el.dataset.ionHoverBound = "1";
  }

  el.dataset.ionLauncherStyled = "1";
  return true;
}

function looksLikeLauncher(el) {
  if (!el || el.nodeType !== 1) return false;

  // Must be visible
  const rect = el.getBoundingClientRect();
  if (rect.width < 44 || rect.height < 44) return false;
  if (rect.width > 110 || rect.height > 110) return false;

  // Must be near bottom-right
  const margin = 80; // generous
  if (rect.right < (window.innerWidth - margin)) return false;
  if (rect.bottom < (window.innerHeight - margin)) return false;

  const cs = window.getComputedStyle(el);

  // Often fixed or absolute
  const posOk = cs.position === "fixed" || cs.position === "absolute";
  if (!posOk) return false;

  // Has an icon inside (your speech bubble)
  const hasIcon = !!el.querySelector("img, svg");
  if (!hasIcon) return false;

  // Background is “teal-ish” OR has a strong glow/shadow
  const bg = cs.backgroundColor || "";
  const shadow = cs.boxShadow || "";
  const tealish = bg.includes("rgb(") && (bg.includes("0, 255") || bg.includes("0,255") || bg.includes("0, 240"));
  const glowy = shadow && shadow !== "none";

  return tealish || glowy;
}

function findIonLauncher() {
  // Try known selectors first
  const known = [
    "#ion-gpt-launcher",
    "#ion-gpt-toggle",
    "#ion-gpt-button",
    "#ion-gpt-fab",
    ".ion-gpt-launcher",
    ".ion-gpt-toggle",
    ".ion-gpt-fab",
    "#ion-gpt-chat-button"
  ];

  for (const sel of known) {
    const el = document.querySelector(sel);
    if (el) return el;
  }

  // Heuristic scan for the real launcher
  const candidates = Array.from(document.querySelectorAll("button, a, div"))
    .filter(el => looksLikeLauncher(el));

  // Prefer the one highest z-index (usually the floating widget)
  let best = null;
  let bestZ = -1;
  for (const el of candidates) {
    const z = parseInt(window.getComputedStyle(el).zIndex || "0", 10);
    if (z > bestZ) { bestZ = z; best = el; }
  }
  return best || null;
}

function enforceLauncherSkin() {
  try {
    const launcher = findIonLauncher();
    if (launcher) styleIonLauncher(launcher);
  } catch (e) {
    // never break anything
    console.warn("ION launcher skin warning:", e);
  }
}

function startLauncherObserver() {
  // Run a few times (widget sometimes mounts late)
  enforceLauncherSkin();
  setTimeout(enforceLauncherSkin, 300);
  setTimeout(enforceLauncherSkin, 1200);
  setTimeout(enforceLauncherSkin, 2500);

  // Observe DOM for late injection / rerenders
  const obs = new MutationObserver(() => {
    const launcher = findIonLauncher();
    if (launcher && launcher.dataset.ionLauncherStyled !== "1") {
      styleIonLauncher(launcher);
    }
  });

  obs.observe(document.body, { childList: true, subtree: true, attributes: true });
  // stop observer after a bit to avoid any long-term overhead
  setTimeout(() => obs.disconnect(), 20000);
}

// ---------- Existing Open/Close ----------
const openIonChat = () => {
  const windowEl = document.getElementById("ion-gpt-window");
  const msgContainer = document.getElementById("ion-gpt-messages");

  const isClosed = windowEl.style.display === "none" || windowEl.style.display === "";
  windowEl.style.display = isClosed ? "block" : "none";

  if (isClosed && msgContainer.childNodes.length === 0) {
    showTypingDots();
    setTimeout(() => {
      const greetings = [
        "Hey there — I’m your hydration concierge. Ask me anything about fasting, fatigue, or how to feel 10% more unstoppable today 💧⚡",
        "Need help with fasting, brain fog, or recovery? I’ve got the science and the sauce.",
        "What would 10% better performance feel like today? Let’s make that your baseline.",
        "Ask me anything — hydration, autophagy, hangovers, or why your creatine isn't hitting 💥",
        "Ready to GO TO THE LYTE? I'm here for your questions, biohacks, and breakthroughs."
      ];
      const greeting = greetings[Math.floor(Math.random() * greetings.length)];
      removeTypingDots();
      appendMessage("ION GPT", greeting, "assistant");
    }, 900);
  }
};

function showTypingDots() {
  const messagesDiv = document.getElementById("ion-gpt-messages");
  if (!document.getElementById("ion-gpt-typing")) {
    const typing = document.createElement("div");
    typing.id = "ion-gpt-typing";
    typing.className = "typing-dots ion-typing";
    typing.innerHTML = "<span></span><span></span><span></span>";
    messagesDiv.appendChild(typing);
    messagesDiv.scrollTo({ top: messagesDiv.scrollHeight, behavior: "smooth" });
  }
}

function removeTypingDots() {
  const typing = document.getElementById("ion-gpt-typing");
  if (typing) typing.remove();
}

function appendMessage(sender, text, role = "assistant") {
  const container = document.getElementById("ion-gpt-messages");
  const wrapper = document.createElement("div");

  wrapper.className = `ion-msg ion-msg--${role === "user" ? "user" : "assistant"}`;

  const label = document.createElement("b");
  label.textContent = `${sender}:`;

  wrapper.appendChild(label);
  wrapper.append(` ${text}`);
  container.appendChild(wrapper);
  container.scrollTo({ top: container.scrollHeight, behavior: "smooth" });

  const maxMessages = 60;
  const all = container.querySelectorAll("div.ion-msg, #ion-gpt-typing");
  if (all.length > maxMessages) {
    const firstMsg = container.querySelector("div.ion-msg");
    if (firstMsg) container.removeChild(firstMsg);
  }
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function safeJsonParse(text) {
  try { return JSON.parse(text); } catch { return null; }
}

function extractAssistantReply(msgData) {
  const assistantMsg = msgData?.data?.find(m => m?.role === "assistant");
  const parts = assistantMsg?.content || [];
  const textPart = parts.find(p => p?.type === "text");
  return textPart?.text?.value || null;
}

async function proxyFetch(path, options = {}) {
  const url = `${ION_PROXY_BASE}${path}`;
  const res = await fetch(url, options);

  const raw = await res.text();
  const json = safeJsonParse(raw);

  if (!res.ok) {
    const msg =
      json?.error?.message ||
      json?.message ||
      raw ||
      `Request failed (${res.status})`;
    const err = new Error(msg);
    err.status = res.status;
    err.raw = raw;
    err.json = json;
    throw err;
  }

  return json ?? raw;
}

const sendIonMessage = async () => {
  const input = document.getElementById("ion-gpt-input");
  const userText = input.value.trim();
  if (!userText) return;

  appendMessage("You", userText, "user");
  input.value = "";
  showTypingDots();

  try {
    const runCreate = await proxyFetch(`/v1/threads/runs`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        assistant_id: ION_ASSISTANT_ID,
        thread: { messages: [{ role: "user", content: userText }] }
      })
    });

    const threadId = runCreate?.thread_id;
    const runId = runCreate?.id;

    if (!threadId || !runId) {
      removeTypingDots();
      appendMessage("ION GPT", "Proxy response missing thread_id/run_id. Check worker passthrough.", "assistant");
      return;
    }

    const start = Date.now();
    let status = "queued";
    let lastErrMsg = null;

    while (status === "queued" || status === "in_progress") {
      if (Date.now() - start > POLL_TIMEOUT_MS) {
        removeTypingDots();
        appendMessage("ION GPT", "Timed out waiting on OpenAI. Try again.", "assistant");
        return;
      }

      await sleep(POLL_INTERVAL_MS);

      const runStatus = await proxyFetch(`/v1/threads/${threadId}/runs/${runId}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      });

      status = runStatus?.status || status;

      const lastError = runStatus?.last_error;
      if (lastError?.message) lastErrMsg = lastError.message;

      if (status === "failed" || status === "cancelled" || status === "expired") {
        removeTypingDots();
        appendMessage("ION GPT", lastErrMsg || `Run status: ${status}. Try again in a moment.`, "assistant");
        return;
      }
    }

    const msgData = await proxyFetch(`/v1/threads/${threadId}/messages?limit=20`, {
      method: "GET",
      headers: { "Content-Type": "application/json" }
    });

    const reply = extractAssistantReply(msgData);

    removeTypingDots();
    appendMessage("ION GPT", reply || "ION GPT is feeling dry. Try again.", "assistant");

  } catch (err) {
    removeTypingDots();
    console.error("ION GPT ERROR:", err);
    appendMessage("ION GPT", err?.message || "Error fetching response.", "assistant");
  }
};

document.addEventListener("DOMContentLoaded", () => {
  injectIonGptPremiumStyles();

  // ✅ UI-only: force launcher skin
  startLauncherObserver();

  const chatWindow = document.getElementById("ion-gpt-window");
  const input = document.getElementById("ion-gpt-input");
  const messagesDiv = document.getElementById("ion-gpt-messages");
  const sendBtn = document.querySelector("#ion-gpt-input-container button");

  if (chatWindow) chatWindow.style.display = "none";

  if (input && sendBtn) {
    input.disabled = false;
    input.readOnly = false;
    input.setAttribute("tabindex", "0");

    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        sendIonMessage();
      }
    });

    sendBtn.addEventListener("click", sendIonMessage);
  }

  if (messagesDiv) {
    messagesDiv.addEventListener("scroll", () => {
      if (messagesDiv.scrollTop > 10) {
        messagesDiv.classList.add("fade-shadow");
      } else {
        messagesDiv.classList.remove("fade-shadow");
      }
    });
  }
});

// NOTE: openIonChat() is expected to be called by your widget button.
// We did not change it; functionality remains identical.